import { PERMISSIONS } from "../roles-permissions/permission-catalog";
import { defineEntityIdentity } from "../_shared/entity-identity.schemas";

export const teamMembersIdentity = defineEntityIdentity({
	definitionKey: "teamMembers",
	pageKey: "teamMembers",
	nameSingular: "teamMember",
	namePlural: "teamMembers",
	relationKey: "teamMember",
	auditKey: "teamMembers",
	storage: "durable",
	grants: {
		read: { ...PERMISSIONS.teamMembers.readAll, audience: "allMembers" },
		create: { ...PERMISSIONS.teamMembers.createAll, audience: "restricted" },
		update: { ...PERMISSIONS.teamMembers.updateAll, audience: "restricted" },
		delete: null
	}
});
